<template>
  <div
    class="bbp-select-users__wrapper"
    :class="[
      isPosCorner && 'bbp-select-users__wrapper_top',
      !isPosCorner && 'bbp-select-users__wrapper_bottom',
    ]"
    @click.stop
    :style="positionStyle"
    @mouseleave="onClose"
  >
    <VuePerfectScrollbar
      class="bbp-select-users"
      v-click-outside="onClose"
      tabindex="0"
      :settings="scrollSettings"
    >
      <div class="bbp-select-users__margin bbp-select-users__margin_top"/>
      <div class="bbp-select-users-user"
           @click.stop="setUser(user)"
           v-for="user in usersList"
           :key="user.id">
        <img
          v-if="user.image"
          class="bbp-select-users-user__image"
          :src="getUserImage(user)"
        />
        <i class="bbp-icon-user bbp-select-users-user__image" v-else/>
        <span class="bbp-select-users-user__username">{{user.username}}</span>
      </div>
      <div class="bbp-select-users__margin bbp-select-users__margin_bottom"/>
    </VuePerfectScrollbar>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import {get} from 'lodash'

export default {
  name: 'BBPSelectUsers',
  props: {
    usersList: {
      type: Array,
      default: () => ([])
    },
    positionStyle: {
      type: Object,
      default: () => ({})
    },
    isPosCorner: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    scrollSettings: { wheelPropagation: false, minScrollbarLength: 25 }
  }),
  components: {
    VuePerfectScrollbar
  },
  methods: {
    getUserImage (user) {
      return get(user, 'image.path', '')
    },
    setUser (user) {
      this.$emit('setUser', user)
    },
    onClose () {
      this.$emit('update:isShow', false)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../sass/variables";
@import "../../../sass/mixins";

  .bbp-select-users {
    overflow: hidden;
    max-height: 194px;
    padding: 0 8px;

    &__wrapper {
      position: absolute;
      top: 34px;
      left: 1px;
      width: auto;
      min-width: 170px;
      background-color: $color-white;
      box-shadow: 0 0 12px rgba($color-black, 0.12);
      border-radius: 5px;
      z-index: 10;

      &_top {
        &:before {
          content: '';
          position: absolute;
          left: 8px;
          top: -5px;
          width: 0;
          height: 0;
          border-style: solid;
          border-width: 0 5px 5px 5px;
          border-color: transparent transparent $color-white transparent;
        }
      }

      &_bottom {
        &:before {
          content: '';
          position: absolute;
          left: 8px;
          bottom: -5px;
          width: 0;
          height: 0;
          border-style: solid;
          border-width: 5px 5px 0 5px;
          border-color: $color-white transparent transparent transparent;
        }
      }
    }

    &__margin {
      position: sticky;
      background-color: $color-white;
      height: 10px;
      width: 100%;
      z-index: 2;

      &_top {
        top: 0;
      }

      &_bottom {
        bottom: 0
      }
    }

    &-user {
      display: grid;
      grid-template-columns: 28px auto;
      grid-gap: 8px;
      align-items: center;
      margin-bottom: 8px;
      font-size: 13px;
      line-height: 16px;
      text-transform: capitalize;
      transition: 0.3s;
      cursor: pointer;

      &:hover {
        color: $color-accent;
      }

      &__image {
        width: 28px;
        height: 28px;
        color: $color-accent;
        object-fit: cover;
        font-size: 28px;
        border-radius: 50%;

        &:before {
          margin: 0;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Main/BBPSelectUsers/BBPSelectUsers.vue